{
	"app_fallbacks": {
		"error": {
			"description": "An unexpected error occurred while rendering this page. You can try again, or head back to a working area of the app.",
			"title": "Something went wrong."
		},
		"go_back": "Go back",
		"go_home": "Go home",
		"loading": "Loading",
		"not_found": {
			"description": "The page you're looking for doesn't exist or may have moved. Head back to a working area of the app.",
			"title": "Page not found."
		},
		"try_again": "Try again"
	},
	"app_sidebar": {
		"brand_logo_alt": "{{product}} logo",
		"console_name": "Backoffice",
		"menu": {
			"logout": "Log out",
			"preferences": "Preferences"
		}
	}
}
